import { cn } from './cn';

type Mods = Record<string, boolean | string>;

/**
 * Генерирует строку классов на основе обязательного класса, модификаторов и дополнительных классов.
 *
 * @param {string} cls - Основной CSS-класс.
 * @param {Mods} [mods={}] - Объект модификаторов, где ключ — имя класса, а значение — условие его применения (true/false или строка).
 * @param {(string | undefined | null)[]} [additional=[]] - Массив дополнительных классов, которые могут быть строками, null или undefined.
 * @returns {string} - Строка с итоговыми CSS-классами, разделёнными пробелами.
 */
export function classNames(cls: string, mods: Mods = {}, additional: (string | undefined | null)[] = []): string {
  return cn(
    [
      cls,
      ...Object.entries(mods)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .filter(([className, value]) => Boolean(value))
        .map(([className]) => className),
      ...additional.filter(Boolean),
    ]
      .filter(className => Boolean(className))
      .join(' '),
  );
}
